// --- API Response Wrapper ---

export type { ApiResponse } from '@/core/models/api-response.model';

// --- Request DTOs ---

/** Body of `POST /api/User/LoginWeb` — field names must match the API exactly. */
export interface LoginRequestDto {
    Username: string;
    Password: string;
}

export interface ForgotPasswordDto {
    emailId?: string | null;
}

export interface CreatePasswordDto {
    userid?: number;
    password?: string | null;
    token?: string | null;
}

export interface ResetPasswordDto {
    otp?: string | null;
    emailId?: string | null;
    password?: string | null;
}

export interface RefreshTokenRequestDto {
    accessToken: string;
    refreshToken: string;
}

// --- Response Data DTOs ---

/** 1 = page access, 2 = button (action) access. */
export type PermissionType = 1 | 2;

export interface UserPermission {
    Permission: string;
    PermissionID: number | string;
    Code: string;
    PermissionType: PermissionType;
    PageID: number | string | null;
}

/** Response of `POST /api/User/LoginWeb`. `Permission` holds both direct and role-based permissions. */
export interface LoginWebResponse {
    FolderPath: string | null;
    UserName: string;
    S3Config: unknown;
    UserID: number | string;
    AccessToken: string;
    Designation: string | null;
    EmployeeID: number | string | null;
    Supervisor: string | null;
    Name: string | null;
    SupervisorID: number | string | null;
    CompanyID: number | string | null;
    Role: unknown[];
    Permission: UserPermission[];
    /** Only users with this flag set may sign in to the PMCC web app. */
    IsPMCCWebApplicable: boolean;
}

/** Thrown by `AuthRepository.login` when the user is not enabled for the PMCC web app. */
export class PmccWebAccessDeniedError extends Error {
    constructor() {
        super('User is not enabled for the PMCC web application');
        this.name = 'PmccWebAccessDeniedError';
    }
}

export interface RefreshTokenData {
    accessToken: string;
    refreshToken: string;
    accessTokenExpiry: string;
    refreshTokenExpiry: string;
}

export interface SuccessData {
    isSuccess: boolean;
}

// --- Permission Types ---

export interface PermissionFlags {
    canView: boolean;
    canCreate: boolean;
    canUpdate: boolean;
    canDelete: boolean;
}
